<script setup lang="ts">
import Dragger from "./Dragger.vue";
import ToolOptionsDropdown from "./toolbar/ToolOptionsDropdown.vue";
import { DraggerType } from "@/drawing";
import DraggerMenuState from "@/stores/DraggerMenuState";
import CloseContourBtn from "./options/CloseContourBtn.vue";
import SmoothenSizeBtn from "./options/SmoothenSizeBtn.vue";
import DisableToolBtn from "./options/DisableToolBtn.vue";
import Settings from "@/stores/Settings";
</script>

<template>
  <ToolOptionsDropdown :owners="[DraggerType.Freehand]">
    <template #tool>
      <Dragger
        :config="{ name: DraggerType.Freehand }"
        phosphor-icon="pencil-simple"
        :tooltip-title="$t('canvas:tools.freehand.tooltip.title')"
        :tooltip-text="$t('canvas:tools.freehand.tooltip.text')"
        @click="
          DraggerMenuState.setActiveDragger({ name: DraggerType.Freehand })
        "
      />
    </template>
    <div class="rounded p-1" style="background-color: var(--canvas-bg)">
      <div class="btn-group-vertical w-100">
        <DisableToolBtn v-if="!Settings.onlyStylusOn" />
        <CloseContourBtn />
      </div>
      <div class="canvas-divider-horizontal my-1"></div>
      <SmoothenSizeBtn />
    </div>
  </ToolOptionsDropdown>
</template>
